export const legacyListingRoutesObj = {
    SLUG_GEO_CAT: '(:lang/)(:geoSlug)_g(:geoID)(/:categorySlug)_c(:categoryID)(/q-:text)',
    SLUG_GEO: '(:lang/)(:geoSlug)_g(:geoID)(/q-:text)',
    SLUG_CATEGORY_ID: '(:lang/)(:categorySlug)_c(:categoryID)(/q-:text)',
    SLUG_ITEM_ID: '(:lang/)(:slug)-iid-:id',
    SLUG_LOCATION_ID: '(:lang/)(:slug)-l-:locationId',
    SLUG_CATEGORY: '(:lang/)(:slug)-c-:category'
};

export const legacyListingRoutesArray = [
    legacyListingRoutesObj.SLUG_GEO_CAT,
    legacyListingRoutesObj.SLUG_GEO,
    legacyListingRoutesObj.SLUG_CATEGORY_ID,
    legacyListingRoutesObj.SLUG_ITEM_ID,
    legacyListingRoutesObj.SLUG_LOCATION_ID,
    legacyListingRoutesObj.SLUG_CATEGORY
];
